
function Loader(props: { type?: 'normal' | 'small' }) {
    const {type = 'normal'} = props
    return (
        <div className={`lds-ring -${type}`}>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            {/* <img src={iconSvg}/> */}
        </div>
    )
}

export default Loader
